// Pinia Store
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { AnalyticsItem } from '~~/common/plugins/aw-analytics';

export const useAnalyticsQueueStore = defineStore('analyticsQueue', () => {
  const queue = ref<AnalyticsItem[]>([]);
  const queueHistory = ref<string[]>([]);

  const addToQueue = (data: AnalyticsItem): void => {
    if (isInHistory(data) || isInQueue(data)) {
      return;
    }
    queue.value.push(data);
  };

  const getQueue = (): AnalyticsItem[] => {
    return queue.value;
  };

  const clearQueue = (): void => {
    if (!queue.value.length) {
      return;
    }
    queue.value?.forEach((item) => {
      const elementIdentifier = getItemIdentifier(item);
      // Use hash or something to identify the element
      queueHistory.value.push(elementIdentifier);
    });
    queue.value = [];
  };

  const isInHistory = (data: AnalyticsItem): boolean => {
    const elementIdentifier = getItemIdentifier(data);
    return queueHistory.value.includes(elementIdentifier);
  };

  const isInQueue = (data: AnalyticsItem): boolean => {
    const elementIdentifier = getItemIdentifier(data);
    return queue.value.some(item => getItemIdentifier(item) === elementIdentifier);
  };

  const clearQueueHistory = (): void => {
    queueHistory.value = [];
  };

  const getItemIdentifier = (data: AnalyticsItem): string => {
    return JSON.stringify(data);
  };

  return {
    queue,
    queueHistory,
    addToQueue,
    getQueue,
    clearQueueHistory,
    clearQueue,
  };
});
